export default {
    name: 'mine/favorites',
    path: 'favorites',
    component: () => import('./Root.vue'),
}